import { supabase } from './supabase';
import { withAbortTimeout } from './async';
import type { Plan } from '../types';
import type {CloudExpiryState} from '../../shared/cloudExpiry';
export interface BillingRights { effectivePlan: Plan; cloudAllowed: boolean; planExpiresAt: string | null; refundedCurrentPeriod: boolean;cloudExpiry?:CloudExpiryState }
export async function fetchBillingRights(userId: string, signal?: AbortSignal): Promise<BillingRights | null> {
  return withAbortTimeout(async (abortSignal) => {
    const session = (await supabase?.auth.getSession())?.data.session;
    if (!session || session.user.id !== userId) return null;
    const response = await fetch('/api/billing/rights', { headers: { authorization: `Bearer ${session.access_token}` }, signal: abortSignal });
    if (!response.ok) return null;
    const value = await response.json().catch(() => null) as (BillingRights & { enabled?: boolean }) | null;
    if (!value?.enabled || !['free','pro','business'].includes(value.effectivePlan) || typeof value.cloudAllowed !== 'boolean') return null;
    return value;
  }, 10000, signal).catch(() => null);
}
